import React, { useState } from 'react';
import { useData } from '../../store/DataContext';
import { Card } from '../../components/ui/Card';
import { Button } from '../../components/ui/Button';
import { Input } from '../../components/ui/Input';
import { Select } from '../../components/ui/Select';
import { Save } from 'lucide-react';
export const Settings: React.FC = () => {
  const {
    currentUser
  } = useData();
  const [settings, setSettings] = useState({
    currency: 'ZMW',
    taxRate: '16',
    invoicePrefix: 'INV-',
    receiptPrefix: 'REC-',
    quotationPrefix: 'QUO-',
    creditNotePrefix: 'CN-',
    paymentTerms: 'Due on Receipt'
  });
  const handleSave = () => {
    // Mock save
    alert('Settings saved successfully.');
  };
  if (currentUser?.role !== 'Administrator') {
    return <div className="p-8 text-center text-red-600" data-id="element-1500">
        Only Administrators can access Billing Settings.
      </div>;
  }
  return <div className="space-y-6 max-w-3xl" data-id="element-1501">
      <div className="flex justify-between items-center" data-id="element-1502">
        <h1 className="text-2xl font-bold text-gray-900" data-id="element-1503">Billing Settings</h1>
      </div>

      <Card title="General Preferences" data-id="element-1504">
        <div className="grid grid-cols-1 md:grid-cols-2 gap-6" data-id="element-1505">
          <Select label="Base Currency" value={settings.currency} onChange={e => setSettings({
          ...settings,
          currency: e.target.value
        })} options={[{
          value: 'ZMW',
          label: 'Zambian Kwacha (ZMW)'
        }, {
          value: 'USD',
          label: 'US Dollar (USD)'
        }]} data-id="element-1506" />
          <Input label="Default Tax Rate (%)" type="number" value={settings.taxRate} onChange={e => setSettings({
          ...settings,
          taxRate: e.target.value
        })} data-id="element-1507" />
          <Select label="Default Payment Terms" value={settings.paymentTerms} onChange={e => setSettings({
          ...settings,
          paymentTerms: e.target.value
        })} options={[{
          value: 'Due on Receipt',
          label: 'Due on Receipt'
        }, {
          value: 'Net 7',
          label: 'Net 7'
        }, {
          value: 'Net 15',
          label: 'Net 15'
        }, {
          value: 'Net 30',
          label: 'Net 30'
        }]} data-id="element-1508" />
        </div>
      </Card>

      <Card title="Numbering Prefixes" data-id="element-1509">
        <div className="grid grid-cols-1 md:grid-cols-2 gap-6" data-id="element-1510">
          <Input label="Invoice Prefix" value={settings.invoicePrefix} onChange={e => setSettings({
          ...settings,
          invoicePrefix: e.target.value
        })} data-id="element-1511" />
          <Input label="Receipt Prefix" value={settings.receiptPrefix} onChange={e => setSettings({
          ...settings,
          receiptPrefix: e.target.value
        })} data-id="element-1512" />
          <Input label="Quotation Prefix" value={settings.quotationPrefix} onChange={e => setSettings({
          ...settings,
          quotationPrefix: e.target.value
        })} data-id="element-1513" />
          <Input label="Credit Note Prefix" value={settings.creditNotePrefix} onChange={e => setSettings({
          ...settings,
          creditNotePrefix: e.target.value
        })} data-id="element-1514" />
        </div>
      </Card>

      <div className="flex justify-end" data-id="element-1515">
        <Button onClick={handleSave} data-id="element-1516">
          <Save className="w-4 h-4 mr-2" data-id="element-1517" /> Save Settings
        </Button>
      </div>
    </div>;
};